import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import BranchMap from "@/components/BranchMap";

export default function Standorte() {
  const [branches, setBranches] = useState([]);
  useEffect(() => { api.get("/branches").then((r) => setBranches(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
      <Seo title="Unsere Standorte – HELIUM Cafeterias in Kliniken" description="Alle HELIUM Cafeteria-Standorte in Schwelm, Wuppertal und Duisburg. Adresse, Öffnungszeiten und Anfahrt." />
      <div className="max-w-2xl">
        <span className="text-xs font-semibold uppercase tracking-wider text-[#E0243A]">Standorte</span>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mt-2 font-display">Unsere Standorte</h1>
        <p className="text-gray-600 mt-3">HELIUM Cafeterias – direkt im Herzen der Kliniken. Finde deinen Standort und plane deinen Besuch.</p>
      </div>

      <div className="mt-8 rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
        <BranchMap branches={branches} height={420} />
      </div>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {branches.map((b) => (
          <div key={b.id} className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm hover:border-[#E0243A]/40 hover:shadow-md transition-all" data-testid={`branch-card-${b.slug}`}>
            <h3 className="text-lg font-semibold">{b.name}</h3>
            <p className="text-sm text-gray-500">{b.hospital_name}</p>
            <div className="mt-4 space-y-2 text-sm text-gray-700">
              <div className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[#E0243A]" /> {b.address?.street}, {b.address?.zip} {b.address?.city}</div>
              <div className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#E0243A]" /> {b.phone}</div>
              <div className="flex items-start gap-2"><Clock className="w-4 h-4 mt-0.5 text-[#E0243A]" />
                <div className="space-y-0.5">
                  <div>Mo–Fr: {b.opening_hours?.["Mo-Fr"]}</div>
                  <div>Sa: {b.opening_hours?.["Sa"]}</div>
                  <div>So: {b.opening_hours?.["So"]}</div>
                </div>
              </div>
            </div>
            <div className="mt-5 flex gap-2">
              <Link to={`/standorte/${b.slug}`} className="flex-1 text-center bg-[#E0243A] hover:bg-[#C81E33] text-white font-semibold py-2.5 rounded-xl text-sm">Details</Link>
              <a href={`https://www.openstreetmap.org/directions?to=${b.lat},${b.lng}`} target="_blank" rel="noreferrer" className="flex-1 text-center border border-gray-200 hover:bg-gray-50 font-medium py-2.5 rounded-xl text-sm">Route planen</a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
